module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "close pull-left",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "button",
      "title": "Remove item"
    },
    on: {
      "click": _vm.remove
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "data-toggle": "validator"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Food Item:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataItem.name),
      expression: "dataItem.name"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.dataItem.name = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("---select a food item---")]), _vm._v(" "), _vm._l((_vm.dataRef.food), function(i) {
    return _c('option', [_vm._v(_vm._s(i.name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Amount:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataItem.amount),
      expression: "dataItem.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.1",
      "placeholder": "Enter amount in gm or ml"
    },
    domProps: {
      "value": _vm._s(_vm.dataItem.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataItem.amount = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('div', {
    staticClass: "help-block with-errors"
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-465d748e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/item.vue
// module id = 143
// module chunks = 0